// import Cookie;
// import Cookies from 'js-cookie';

export default {
  init() {
    // JavaScript to be fired on all pages
    $("#SideMenu").mmenu({
      "counters" : true,
      navbars		: {
        content : [ "prev",'<p class="title"><a href="'+$('.title-hidden').attr('data-url')+'">'+$('.title-hidden').attr('data-title')+'</a></p>',"close" ],
        height 	: 1,
      },
      "extensions": [
         "position-front",
         "pagedim-black",
         "border-offset",
      ],
    });

    $('.all-services, .menu-icon-trigger').on('click', function() {
      $('.mega-menu').show();
      $('body').addClass('menu-active');
      return false;
    });

    $('.close-btn').on('click', function(){
      $('.mega-menu, .search-menu').hide();
      $('body').removeClass('menu-active');
    });

    $('.searching-for').on('click', function() {
      $('.search-menu').show();
      $('body').addClass('menu-active');
      return false;
    });

    $('.in-the-news-slider').slick({
      // centerMode: true,// Default: false
      infinite: false,// Default: true
      // slidesToShow: 3,
      // slidesToScroll: 3,
      slidesToShow: 1,
      mobileFirst: true,// Default: false
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 996,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });
    
    // Featured/other services slider
    $('.featured-slider').slick({
      // slidesToShow: 1,// Default: 1
      // slidesToScroll: 1,// Default: 1
      rows: 0,// Fix bug causing extra divs
      infinite: false,// Default: true
      mobileFirst: true,// Default: false
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });
    
    // Testimonial slider
    $('.testimonial-slider').slick({
      // slidesToShow: 1,// Default: 1
      // slidesToScroll: 1,// Default: 1
    });
    
    // Custom slider
    $('.custom-slider').slick({
      // slidesToShow: 1,// Default: 1
      // slidesToScroll: 1,// Default: 1
      rows: 0,// Default: 1 | Remove extra divs used for grid mode
      infinite: false,// Default: true
    });
    
    // Custom slider
    $('.card-slider').slick({
      // slidesToShow: 3,// Default: 1
      // slidesToScroll: 1,// Default: 1
      rows: 0,// Default: 1 | Remove extra divs used for grid mode
      dots: true,// Default: false
      arrows: false,// Default: true
      infinite: false,// Default: true
      mobileFirst: true,// Default: false
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });
    
    // Testimonial slider - updated appearance for new full-width locations template
    $('.testimonial-slider-new').slick({
      // slidesToShow: 1,// Default: 1
      rows: 0,// Default: 1 | Remove extra divs used for grid mode
      dots: true,// Default: false
      arrows: false,// Default: true
      // dotsClass: 'slick-dots',// Default: 'slick-dots'
      infinite: false,// Default: true
      // autoplay: true,// Default: false
      // autoplaySpeed: 5000,// Default: 3000
      // infinite: false// Default: true
    });
    
    // Service slider on new full-width locations template
    // Set preferred slidesToShow on large screens
    // var slidesToShow = 5;
    // var childElements = $('.icon-slider').children().length;
    // Check if we can fulfill the preferred slidesToShow
    /*if( childElements < slidesToShow) {
      // Change slidesToShow to number of slides
      slidesToShow = childElements;
    }*/

    $('.service-slider').each(function () {
      const max_columns = $(this).data('max-columns') || 4;

      $(this).slick({
        // slidesToShow: 5,// Default: 1
        rows: 0,// Fix bug causing extra divs
        // dots: true,// Default: false
        // arrows: false,// Default: true
        infinite: false,// Default: true
        // appendArrows:'.slider-container',
        mobileFirst: true,// Default: false
        responsive: [
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 991,
            settings: {
              // slidesToShow: slidesToShow,
              slidesToShow: max_columns,
            },
          },
        ],
      });
    });
    
    // $('.service-slider').slick({
    //   // slidesToShow: 5,// Default: 1
    //   rows: 0,// Fix bug causing extra divs
    //   // dots: true,// Default: false
    //   // arrows: false,// Default: true
    //   infinite: false,// Default: true
    //   // appendArrows:'.slider-container',
    //   mobileFirst: true,// Default: false
    //   responsive: [
    //     {
    //       breakpoint: 575,
    //       settings: {
    //         slidesToShow: 2,
    //       },
    //     },
    //     {
    //       breakpoint: 767,
    //       settings: {
    //         slidesToShow: 3,
    //       },
    //     },
    //     {
    //       breakpoint: 991,
    //       settings: {
    //         // slidesToShow: slidesToShow,
    //         slidesToShow: $(this).data('columns') || 4,
    //       },
    //     },
    //   ],
    // });
    
    // Video slider on hall of famers page
    $('.video-slider').slick({
      // slidesToShow: 5,// Default: 1
      rows: 0,// Fix bug causing extra divs
      dots: true,// Default: false
      dotsClass: 'slick-dots slick-dots-white',// Default: 'slick-dots'
      arrows: false,// Default: true
      infinite: false,// Default: true
      // appendArrows:'.slider-container',
      mobileFirst: true,// Default: false
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
      ],
    });

    $('.resource-tool-select').on('change', function() {
      $(".resourse-tool-list").each(function () {
				$(this).removeClass("active");
      });
      $("#"+this.value).addClass("active");
    })

    var frm = $('#signip_callout_form');
    frm.submit(function () {
      var email = $.trim($("#signip_callout_email").val());
      var searchURL = $(this).attr('action');
      searchURL += "?email=" + encodeURIComponent(email);
      window.location = searchURL;
      return false;
    });

    var frm_side = $('#signip_callout_form_side');
    frm_side.submit(function () {
      var email = $.trim($("#signip_callout_email_side").val());
      var searchURL = $(this).attr('action');
      searchURL += "?email=" + encodeURIComponent(email);
      window.location = searchURL;
      return false;
    });

    /*var frm_search = $('#search_menu_form');
    frm_search.submit(function () {
      var search_term = $.trim($("#search_menu_search").val());
      var searchURL = $(this).attr('action');
      searchURL += encodeURIComponent(search_term)+"/";
      window.location = searchURL;
      return false;
    });*/

    $(document).on('keyup',function(evt) {
      if (evt.keyCode == 27) {
        if($('.mega-menu').is(':visible')) {
          $('.mega-menu').hide();
        }
      }
    });

    /*$( ".testimonials-page .callout" ).mouseenter(function() {
      $('.callout').css('opacity', '0.3');
      $(this).css('opacity', '1');
    }).mouseleave(function() {
      $('.callout').css('opacity', '1');
    });*/
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    // Cookies.set('name', 'value');
  },
};
